import { LINE_ITEM } from 'customer-data-objects/constants/ObjectTypes';
const shouldDisplayCheckbox = (property, objectType, enableCheckboxInput) => enableCheckboxInput && property.name === 'hs_optional' && objectType === LINE_ITEM;
export default shouldDisplayCheckbox;